import { lang, country_locale } from './index'

let Phone_REG: RegExp;
let Phone_REG_info = '手机号格式不正确'

switch (country_locale) {
  case 'CN':
    Phone_REG = /^[0-9]{8,13}$/
    break
  case 'ID':
    Phone_REG = /^(0|62|\+62)\d{7,14}$/
    Phone_REG_info = '只能输入0/62/+62开头7到14位数字'
    break
  case 'MY':
    Phone_REG = /^[0-9]{9,12}$/
    // Phone_REG_info = '只能输入9到12位数字'
    break
  default:
    Phone_REG = /^[0-9]{8,13}$/
    break
}

const regSpecial = /[\\:*?<>|\]\[]/
// @ts-ignore
const regEmoj = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/
const regNumber = /^[0-9]*$/
/**包牌号 */
export const BAG_NUM = /^(([FLEfle]\d{8})|([Bb]\d{9}))$/
/**Shopee运单号 */
export const SHOPEE_BILLNO = /^62\d{13}$/
/**普通运单号 */
export const WAY_BILL = /^6\d{11,14}$/
/**MPS主单号 */
export const MPS_NUM_MAIN = /^67\d{10}$/
/**MPS子单号 */
export const MPS_NUM_SUB = /^67\d{10}-\d{1,9}$/

/**手机号 8 - 11位数字 */
export const MOBILE_REG = /^[0-9]{8,13}$/
/**密码 字母数字组合8 - 20位 */
export const PWD_REG = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
/**手机号中间四位脱敏 , 前置60 第五位开始加密*/
export const ENCRYPT_PHONE_REG = /(\d{4})\d*(\d{4})/
/** 用户名+@+网站域名 */
export const EMAIL_REG = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
/**金额正则 */
export const PRICE_REG = /^([1-9]\d{0,9}|0)(\.\d{1,2})?$/
/**1-10位大写字母/数字 */
export const tenNumber = /^[A-Z0-9]{1,10}$/
/**
 * 获取自定义校验promise结果
 * @param regResult 匹配完成的结果
 * @param text 提示
 * @returns promise
 */
const getValidtor = (regResult: (val: string) => boolean, text: string) => (_: any, value: string) => {
  if (value && regResult(value)) return Promise.reject(lang(text))
  return Promise.resolve()
}

type regType = (val?: string) => Record<string, any>
/**必填 */
export const requireText: regType = (text) => ({
  required: true,
  message: lang(text || '此项不能为空'),
  trigger: ['change', 'blur']
})
/** 包牌号 */
export const bagNum: regType = (text) => ({
  validator: getValidtor((val) => !BAG_NUM.test(val), text || '请输入正确的包牌号')
})
/** 特殊字符 */
export const specialText: regType = (text) => ({
  validator: getValidtor((val) => regSpecial.test(val), text || '不允许输入特殊字符')
})
/**emoj表情 */
export const emoj: regType = (text) => ({
  validator: getValidtor((val) => regEmoj.test(val), text || '不能存在emoj表情符！')
})
/**emoj表情 特殊字符 */
export const emojAdSpecialText: regType = (text) => ({
  validator: getValidtor((val) => regEmoj.test(val) || regSpecial.test(val), text || '不能存在emoj表情符和特殊字符！')
})
/**数字 */
export const NumberText: regType = (text) => ({
  validator: getValidtor((val) => !regNumber.test(val), text || '请输入数字')
})

/**手机号 */
export const mobileReg: regType = (text) => ({
  validator: getValidtor((val) => !Phone_REG.test(val), text || lang(Phone_REG_info))
})
export const phone13Reg: regType = (text) => ({
  validator: getValidtor((val: any) => !/^[0-9]{8,13}$/.test(val), text || '手机号格式不正确')
})
/**密码 */
export const pwdReg: regType = (text) => ({
  validator: getValidtor((val) => !PWD_REG.test(val), text || '密码长度8-20位，包含大小写字母数字等类型中两种')
})

/**体积校验 */
export const checkVolume = (e: any, volume: Record<string, 'len | width | height'>) => {
  console.log(Object.values(volume).filter((_) => _))

  if (volume.len && volume.width && volume.height) {
    return Promise.resolve()
  }
  return Promise.reject(new Error(lang('请输入体积')))
}
/**邮箱 */
export const emailReg: regType = (text) => ({
  validator: getValidtor((val) => !EMAIL_REG.test(val), text || '邮箱格式不正确')
})
/**邮编 用户输入小写字母，除字母和数字外，其他字符无法输入。*/
export const postCodeReg: regType = (text) => ({
  validator: getValidtor((val) => !/[A-Z\d]{1,10}/g.test(val), text || '1-10位大写字母/数字')
})

/** 长宽高体积之和不超过300*/
export const volumeReg: regType = (text) => ({
  validator: getValidtor((val: any) => val.len + val.width + val.height > 300, text || '三边之和不超过300cm')
})
/** 输入一个必须全输入*/
export const volumeAllValReg: regType = (text) => ({
  validator: getValidtor((val: any) => {
    const len = Object.values(val).filter((_) => _).length
    return len === 1 || len === 2
  }, text || '补全长宽高')
})
/** 金额*/
export const priceReg: regType = (text) => ({
  validator: getValidtor((val: any) => PRICE_REG.test(val), text || '金额有误')
})

export const MyValidator: regType = (text) => ({
  validator: getValidtor((val: any) => val.length < 10 , text || '长度不能小于10'),
  trigger: ['change', 'blur']
})
